import { Box, FormControl, FormGroup, FormControlLabel, Switch, Typography } from "@mui/material";

const SettingSwitch = ({
  label,
  checked,
  onChange,
  description = "",
  disabled = false,
  sx = {},
}) => {
  return (
    <Box sx={{ width: "100%", mb: 2, ...sx }}>
      <FormControl variant="standard">
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={checked}
                onChange={onChange}
                disabled={disabled}
              />
            }
            label={label}
          />
          {description && (
            <Typography variant="caption" >
              {description}
            </Typography>
          )}
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default SettingSwitch;